/**
* =========================================================================================
* Input Skeleton
* =========================================================================================
*/

import React from 'react';

export const ISkeleton = props => {
    
    return (
        <React.Fragment>
            <div className="u_skeleton-input">
                <div className="u_loading" />
            </div>
        </React.Fragment>
    );
};

export const InputColSkeleton = props => {
    
    return (
        <React.Fragment>
            {
                Array.from(Array(props?.cols).keys()).map(i => {
                    return <div className={`u_col-${props?.colSize} u_mb-25${props?.className ? ` ${props?.className}` : ''}`} key={i}><div className="u_skeleton-input">
                        <div className="u_loading" />
                    </div></div>
                })
            }
        </React.Fragment>
    );
};

